import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import UserHeadset from 'assets/images/icons/user-headset.svg';
import SafetyDesignIcon from 'assets/images/icons/safety-design-icon.svg';
import LinkIcon from 'assets/images/icons/new-window-icon.svg';
import useStore from 'state/state';
import { shape, bool } from 'prop-types';

import styles from './Sections.module.scss';

const Sections = ({ data, animateOut }) => {
  const setPaperStartPosition = useStore(
    (state) => state.setAnimatedBoxStartPosition
  );
  const setIsArticleOpen = useStore((state) => state.setIsArticleOpen);
  const setIsContactOpen = useStore((state) => state.setIsContactOpen);
  const appData = useStore((state) => state.appData);

  const [hasArticles, setHasArticle] = useState(false);

  useEffect(() => {
    if (data.articles.length > 0) {
      setHasArticle(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openArticle = (event) => {
    const articleButton = event.target.closest('#articleButton');
    if (articleButton) {
      const dimensions = articleButton.getBoundingClientRect();
      setPaperStartPosition(dimensions);
    }
    setIsArticleOpen(true);
  };

  const openContact = (event) => {
    const contactButton = event.target.closest('#contactButton');
    if (contactButton) {
      const dimensions = contactButton.getBoundingClientRect();
      setPaperStartPosition(dimensions);
    }
    setIsContactOpen(true);
  };

  return (
    <div
      className={clsx(styles.wrapper, {
        [styles.animateOut]: animateOut,
        [styles.missingPapers]: !hasArticles,
      })}
    >
      {hasArticles && (
        <button
          id="articleButton"
          type="button"
          onClick={openArticle}
          className={styles.articles}
        >
          <div className={styles.paperImage} />
          <span>{appData.mainData.overallApp.articleText}</span>
        </button>
      )}
      <button
        type="button"
        onClick={openContact}
        id="contactButton"
        className={clsx(styles.contact, {
          [styles.fullWidth]: !hasArticles,
        })}
      >
        <UserHeadset />
        <span>{appData.mainData.overallApp.contactUsText}</span>
      </button>
      {appData.mainData.safetyDesignBanner && (
        <div className={styles.safetyDesign}>
          <SafetyDesignIcon />

          <span>{appData.mainData.safetyDesignBanner.text}</span>

          <a
            className={styles.listLink}
            href={appData.mainData.safetyDesignBanner.link.url}
            target={appData.mainData.safetyDesignBanner.link.target}
          >
            <LinkIcon />
            <p className={styles.linkText}>
              {appData.mainData.safetyDesignBanner.link.text}
            </p>
          </a>
        </div>
      )}
    </div>
  );
};

Sections.propTypes = {
  data: shape({}).isRequired,
  animateOut: bool.isRequired,
};

export default Sections;
